/**
 * requestAnimationFrame loop with clamped delta time and automatic pause
 * while the tab is hidden (no snow accumulation or paint fade happens
 * off-screen, and dt spikes after a tab switch are swallowed).
 */
export class GameLoop {
  private rafId = 0;
  private last = 0;
  private running = false;

  constructor(private readonly tick: (dt: number, elapsed: number) => void) {
    document.addEventListener('visibilitychange', () => {
      // Reset the clock so the hidden interval doesn't arrive as a giant dt.
      this.last = performance.now();
    });
  }

  start(): void {
    if (this.running) return;
    this.running = true;
    this.last = performance.now();
    const frame = (now: number) => {
      if (!this.running) return;
      const dt = Math.min((now - this.last) / 1000, 0.05);
      this.last = now;
      if (!document.hidden) this.tick(dt, now / 1000);
      this.rafId = requestAnimationFrame(frame);
    };
    this.rafId = requestAnimationFrame(frame);
  }

  stop(): void {
    this.running = false;
    cancelAnimationFrame(this.rafId);
  }
}
